export enum InitializeCartConstants {
  COUNTRY_CODE = 'US',
  CURRENCY_CODE = 'USD',
  APPLICATION = 'connect-looseleaf',
}